import angular from 'angular';
import notFound from './notFound/notFound';
import menu from './menu/menu';
import home from './home/home';
import news from './news/news';
import newsPost from './newsPost/newsPost';
import artists from './artists/artists';
import artist from './artist/artist';
import instagram from './instagram/instagram';
import folio from './folio/folio';
import folioCollection from './folioCollection/folioCollection';
import search from './search/search';
import contact from './contact/contact';

const componentModule = angular.module('app.components', [
  notFound.name,
  menu.name,
  home.name,
  news.name,
  newsPost.name,
  artists.name,
  artist.name,
  instagram.name,
  folio.name,
  folioCollection.name,
  search.name,
  contact.name,
]);

export default componentModule;
